<template>
  <div class="dashboard-container" v-if="deviceStore.type == 'desktop'">
    <h2>后台界面</h2>
    <p>欢迎来到后台管理系统！</p>
    <el-button @click="logout">注销</el-button>
  </div>
  <div v-else-if="deviceStore.type == 'mobile'" class="mobile_div">
    <div class="top_div">
      <component :is="currentComponent" :datainfo="dataInfo" @jump="jumpPage" :searchNow="searchNow" />
    </div>
    <div class="bottom_div">
      <div @click="clickHome">
        <div v-html="homesvg"></div>
        <div>首页</div>
      </div>
      <div @click="clickProcess">
        <div v-html="processsvg"></div>
        <div>流程</div>
      </div>
      <div @click="clickPersonal">
        <div v-html="personalsvg"></div>
        <div>个人中心</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDeviceStore } from '@/stores/device.js';
import { svgRead } from '@/svgIcon/main';

export default {
  name: 'DashboardPage',
  data() {
    return {
      personalsvg: '',
      homesvg: '',
      processsvg: '',
      clickedColor: "rgb(18 136 255)",/**选中后的颜色 */
      noClickedColor: "rgb(136, 137, 138)",/**未选中的颜色 */
      clickState: '',
      currentComponent: '',
      dataInfo: { "types": "", "isOnUserClick": true },
      searchNow: false
    }
  },
  setup() {
    const deviceStore = useDeviceStore();
    console.log("打印用户设备类型");
    console.log(deviceStore.type);
    return { deviceStore };
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$router.push({ name: 'LoginPage' });
    },
    clearClickState(value) {
      this.homesvg = svgRead("home-a", this.noClickedColor, 30, 30);
      this.personalsvg = svgRead('personal-a', this.noClickedColor, 30, 30);
      this.processsvg = svgRead("process-a", this.noClickedColor, 30, 30);
      if (value == 'home') {
        this.homesvg = svgRead("home-a", this.clickedColor, 30, 30);
        this.currentComponent = "HomePage";
      }
      if (value == 'personal') {
        this.personalsvg = svgRead('personal-a', this.clickedColor, 30, 30);
        this.currentComponent = "PersonalPage";
      }
      if (value == 'process') {
        this.processsvg = svgRead("process-a", this.clickedColor, 30, 30);
        this.currentComponent = "ProcessPage";
      }

    },
    clickHome() {
      if (this.clickState != 'home') {
        this.clickState = 'home';
        this.clearClickState(this.clickState);

      }

    },
    clickProcess() {
      if (this.clickState != 'process') {
        this.clickState = 'process';
        this.clearClickState(this.clickState);

      }
    },
    clickPersonal() {
      if (this.clickState != 'personal') {
        this.clickState = 'personal';
        this.clearClickState(this.clickState);

      }
    },
    jumpPage(data) {
      if (data.page == "Process") {
        this.clickProcess();
        this.dataInfo = { "types": data.types, "isOnUserClick": false };
        this.searchNow = true;
      }

    }
  },
  mounted() {
    this.clickState = 'home';
    this.clearClickState(this.clickState);
    localStorage.setItem('current_address', 'DashboardPage');
    this.$socket.on('background_login', (data) => {
      if (this.$socket.diversion(data).success) {
        if (data.notify) {
          if (data.notifyType == 'message') {
            this.$messageX.xiaoxiti("i", data.message);
          } else if (data.notifyType == 'confirm') {
            confirm(data.message);
          } else {
            console.error('回传数据包错误！');
          }
        }
        localStorage.clear();
        this.$router.push({ name: 'LoginPage' });
      }
    });
  }
};
</script>

<style scoped>
.cs {
  color: rgb(136, 137, 138);
}

.dashboard-container {
  text-align: center;
  margin-top: 60px;
}

.mobile_div {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-evenly;
  align-items: center;
}

.bottom_div {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  box-shadow: 9px 8px 30px 5px rgba(0, 0, 0, 0.15);
}

.top_div {
  width: 100%;
  height: calc(100% - 80px);
  background-color: rgb(250 250 250);
}

.touxiang_div {
  border-radius: 100%;
  background-color: rgb(0, 149, 248);
  height: 50px;
  width: 50px;
  margin-right: 10px;
  border: 2px solid #0150d8;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
